import React, { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { Ifilter } from "../../../Interfaces/filter";
import EquipoModeloService from "../../../services/ListaVerificacion/EquipoModeloService";

const UseComboModelo = (isOpen: boolean) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filter, setFilter] = useState<Ifilter>({
        skip: 0,
        take: 20,
        search: ""
    });
    const [dataComboModelo, setDataComboModelo] = useState<IComboBoxOption[]>([]);

    const comboBoxRefModelo = useRef<IComboBox>(null);
    const onClickComboModelo = () => comboBoxRefModelo.current?.focus(true);
    const _openOption = useCallback(
        () => comboBoxRefModelo.current?.focus(true),
        []
    );
    const _onkeyUpSearchModelo = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefModelo.current?.focus(false);
            setFilter({
                skip: 0,
                take: 20,
                search: ""
            });
        } else {
            _openOption();
            let { value } = event?.target as HTMLInputElement;
            setFilter({ ...filter, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        EquipoModeloService.PostListarCombo(filter).then((res) => {
            if (res.status === 200) {
                setDataComboModelo(res.data);
            }
        });
    };


    useEffect(() => {
        listarCombo();
    }, [isOpen]);

    return {
        dataComboModelo,
        onClickComboModelo,
        _onkeyUpSearchModelo,
        comboBoxRefModelo,
    };
}

export { UseComboModelo }
